// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AspectRatio_wrapper__1XBiw","wrapper__1":"AspectRatio_wrapper__1__1igsa","wrapper__2":"AspectRatio_wrapper__2__3qmrW"};